import React from 'react';
import Grid from '@mui/material/Grid';
import { GridSection, GridLeft, GridRight } from '../../../Episode.Styled';
import {
  CalOMSAdmitSubHeading,
  CheckboxGridItems,
} from '../AuthTabCommonUtils';
import {
  getYesNo,
  fotpPriorityStatus,
  arrestedDays,
  drugUsedDays,
  notSureYesNo,
  getMedicationForTreatment,
  getLivingArrangements,
  getSexualityDetails,
} from '../authTabConstants';
import {
  leg8,
  med1,
  med2,
  med3,
  med4,
  med5,
  med7,
  med8,
  med9,
  med10,
  med11,
  med12,
  mhd1,
  mhd2,
  mhd3,
  mhd4,
  soc1,
  soc2,
  soc3,
  soc4,
  soc5,
  soc6,
  soc7,
  soc8,
  lgbtq,
} from './CalOMSQuestionnaireConstants';

const PageFourCalOMS = () => {
  return (
    <Grid container>
      <GridSection mx={2} item container spacing={1}>
        <GridLeft item container xs={6}>
          <CalOMSAdmitSubHeading title="Legal / Criminal Justice (continued)" />

          <CheckboxGridItems
            heading="LEG-8"
            data={fotpPriorityStatus}
            text={leg8}
          />

          <CalOMSAdmitSubHeading title="Medical / Physical Health" />

          <CheckboxGridItems heading="MED-1" data={getYesNo} text={med1} />

          <CheckboxGridItems heading="MED-2" data={arrestedDays} text={med2} />

          <CheckboxGridItems heading="MED-3" data={drugUsedDays} text={med3} />

          <CheckboxGridItems heading="MED-4" data={drugUsedDays} text={med4} />

          <CheckboxGridItems heading="MED-5" data={notSureYesNo} text={med5} />

          <CheckboxGridItems
            heading="MED-7"
            data={getMedicationForTreatment}
            text={med7}
          />

          <CheckboxGridItems heading="MED-8" data={getYesNo} text={med8} />

          <CheckboxGridItems heading="MED-9" data={getYesNo} text={med9} />

          <CheckboxGridItems heading="MED-10" data={getYesNo} text={med10} />

          <CheckboxGridItems heading="MED-11" data={getYesNo} text={med11} />

          <CheckboxGridItems heading="MED-12" data={getYesNo} text={med12} />
        </GridLeft>

        <GridRight item container xs={6}>
          <CalOMSAdmitSubHeading title="Mental Health" />

          <CheckboxGridItems heading="MHD-1" data={notSureYesNo} text={mhd1} />

          <CheckboxGridItems heading="MHD-2" data={arrestedDays} text={mhd2} />

          <CheckboxGridItems heading="MHD-3" data={drugUsedDays} text={mhd3} />

          <CheckboxGridItems heading="MHD-4" data={getYesNo} text={mhd4} />

          <CalOMSAdmitSubHeading title="Social / Family" />

          <CheckboxGridItems heading="SOC-1" data={drugUsedDays} text={soc1} />

          <CheckboxGridItems
            heading="SOC-2"
            data={getLivingArrangements}
            text={soc2}
          />

          <CheckboxGridItems heading="SOC-3" data={drugUsedDays} text={soc3} />

          <CheckboxGridItems heading="SOC-4" data={drugUsedDays} text={soc4} />

          <CheckboxGridItems heading="SOC-5" data={drugUsedDays} text={soc5} />

          <CheckboxGridItems heading="SOC-6" data={drugUsedDays} text={soc6} />

          <CheckboxGridItems heading="SOC-7" data={drugUsedDays} text={soc7} />

          <CheckboxGridItems heading="SOC-8" data={drugUsedDays} text={soc8} />

          <CheckboxGridItems
            heading="LGBTQ"
            data={getSexualityDetails}
            text={lgbtq}
          />
        </GridRight>
      </GridSection>
    </Grid>
  );
};

export default PageFourCalOMS;
